import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useCart } from '../contexts/CartContext';
import { LogOut, LayoutDashboard, LogIn, ShoppingCart } from 'lucide-react';

const NAV_LOGO_URL = "https://customer-assets.emergentagent.com/job_widget-studio-19/artifacts/cfszi269_Firefly_Use%20teh%20clean%20one%20from%20this%20set%20and%20change%20Widgets%20%26%20AI%20Solutions%20to%20AI%20Driven%20Innova%2050267.png";

export const Navbar = () => {
  const { user, logout } = useAuth();
  const { itemCount } = useCart();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const isAuthed = user && user !== false;

  return (
    <nav className="backdrop-blur-xl bg-[#0F1113]/75 border-b border-subtle sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <div className="riveted-frame">
              <div className="h-14 w-44 overflow-hidden rounded-[10px]">
                <img
                  src={NAV_LOGO_URL}
                  alt="LAB21g Logo"
                  className="w-full h-full object-cover"
                  style={{ objectPosition: 'center 60%' }}
                />
              </div>
            </div>
          </Link>

          <div className="flex items-center space-x-7">
            <a
              href="/#services"
              className="text-default hover:text-strong transition-colors text-sm font-medium"
              data-testid="nav-services"
            >
              Services
            </a>

            {isAuthed ? (
              <Link
                to="/dashboard"
                className="flex items-center space-x-1.5 text-default hover:text-strong transition-colors text-sm font-medium"
                data-testid="nav-my-widgets"
              >
                <LayoutDashboard className="w-4 h-4" />
                <span>My Widgets</span>
              </Link>
            ) : (
              <a
                href="/#widgets"
                className="text-default hover:text-strong transition-colors text-sm font-medium"
                data-testid="nav-widgets"
              >
                Widgets
              </a>
            )}

            <a
              href="/#about"
              className="text-default hover:text-strong transition-colors text-sm font-medium hidden sm:inline-block"
              data-testid="nav-about"
            >
              About
            </a>

            <a
              href="/#contact"
              className="btn-primary px-5 py-2.5 text-sm inline-flex items-center"
              data-testid="nav-contact-button"
            >
              Contact
            </a>

            <Link
              to="/cart"
              className="relative flex items-center space-x-1.5 text-default hover:text-strong transition-colors text-sm font-medium"
              data-testid="nav-cart-link"
              aria-label="Cart"
            >
              <ShoppingCart className="w-4 h-4" />
              {itemCount > 0 && (
                <span
                  className="absolute -top-2 -right-2 min-w-[18px] h-[18px] px-1 rounded-full text-[10px] font-bold flex items-center justify-center bg-[#39FF14] text-black"
                  data-testid="nav-cart-count"
                >
                  {itemCount}
                </span>
              )}
            </Link>

            {isAuthed ? (
              <button
                onClick={handleLogout}
                className="flex items-center space-x-1.5 text-faded hover:text-strong transition-colors text-sm font-medium"
                data-testid="nav-logout-button"
              >
                <LogOut className="w-4 h-4" />
                <span>Logout</span>
              </button>
            ) : (
              <Link
                to="/login"
                className="flex items-center space-x-1.5 text-faded hover:text-strong transition-colors text-sm font-medium"
                data-testid="nav-login-link"
              >
                <LogIn className="w-4 h-4" />
                <span>Login</span>
              </Link>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};
